import * as z from 'zod';

import { type UseFormReturn } from 'react-hook-form';

import { AuditEcmsFormSchema } from '#packages/data-collection/models/audit-ecms-form';

export const EditAuditFormEcmsDataSchema = AuditEcmsFormSchema.omit({
  type: true,
});
export type EditAuditFormEcmsData = z.infer<typeof EditAuditFormEcmsDataSchema>;

export type EditAuditFormEcms = UseFormReturn<EditAuditFormEcmsData>;
